export default __webpack_public_path__ + "static/media/logo_ue_cofinance.9ede800b.jpg";